import { render, staticRenderFns } from "./order-received.vue?vue&type=template&id=e7c250c8"
import script from "./order-received.vue?vue&type=script&lang=ts"
export * from "./order-received.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/vercel/path0/components/navbar.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
